import React from "react";
import MaterialTableRtl from "../../components/UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUE_AUDITS } from "../../service/ApolloClient/ApolloQueries";
import { Box, Grid } from "@material-ui/core";
import { withRouter } from "react-router";
import "react-confirm-alert/src/react-confirm-alert.css";
import ShowAuditRow from "./Audit/ShowAuditRow";
import { DehazeOutlined } from "@material-ui/icons";

class ChequeAuditsList extends React.Component {
  tableRef = React.createRef();

  filedUser;

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      search: {},
      columns: [
        { title: "شماره چک", field: "Cheque.cheque_id" },
        {
          title: "نوع تغییر",
          field: "event",
          render: (rowData) =>
            rowData.event === "updated" ? "به روز رسانی" : "ایجاد",
        },
        {
          title: "تغییر دهنده",
          field: "User.name",
          render: (rowData) =>
            rowData.User ? (
              <a href={`/person/edit/${rowData.User.id}`}>
                {rowData.User.name}
                {rowData.User.lastname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {},
        {
          title: "زمان تغییر",
          field: "created_at",
        },
      ],
      detailPanel: [
        {
          icon: () => <DehazeOutlined />,
          tooltip: "مشاهده جزییات",
          render: (rowData) => {
            const oldV = JSON.parse(JSON.parse(rowData.old_values));
            const newV = JSON.parse(JSON.parse(rowData.new_values));

            return (
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "c9c9c9",
                }}
              >
                {Object.keys(oldV).length > 0 ? (
                  <Grid container={true} style={{ padding: 10 }}>
                    {Object.keys(oldV).length == 1 ? (
                      <>
                        <Grid item md={6}>
                          <Box style={{ marginLeft: 10 }}>
                            <table style={{width: "100%", border: "1px solid white",}}>
                              <thead>
                                <tr>
                                  <th style={{width: "30%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    عنوان
                                  </th>
                                  <th style={{width: "30%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    از
                                  </th>
                                  <th style={{width: "40%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    به
                                  </th>
                                </tr>
                              </thead>
                            </table>
                          </Box>
                        </Grid>
                        <Grid item md={6}></Grid>
                      </>
                    ) : (
                      <>
                        <Grid item md={6}>
                          <Box style={{ marginLeft: 10 }}>
                            <table style={{width: "100%", border: "1px solid white",}}>
                              <thead>
                                <tr>
                                  <th style={{width: "30%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    عنوان
                                  </th>
                                  <th style={{width: "30%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    از
                                  </th>
                                  <th style={{width: "40%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    به
                                  </th>
                                </tr>
                              </thead>
                            </table>
                          </Box>
                        </Grid>
                        <Grid item md={6}>
                          <Box style={{ marginLeft: 10 }}>
                            <table style={{width: "100%", border: "1px solid white",}}>
                              <thead>
                                <tr>
                                  <th style={{width: "30%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    عنوان
                                  </th>
                                  <th style={{width: "30%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    از
                                  </th>
                                  <th style={{width: "40%", textAlign: "right", border: "none", fontWeight: "bold",}}>
                                    به
                                  </th>
                                </tr>
                              </thead>
                            </table>
                          </Box>
                        </Grid>
                      </>
                    )}
                    {Object.keys(oldV).map((o) => {
                      return (
                        <ShowAuditRow
                          key={o}
                          cheque={rowData?.Cheque}
                          rowDataNew={newV}
                          rowDataOld={oldV}
                          field={o}
                          value={oldV[o]}
                          old={newV[o]}
                        />
                      );
                    })}
                  </Grid>
                ) : (
                  <div style={{ textAlign: "center", padding: "10px" }}>
                    تغییری در داده رخ نداده است
                  </div>
                )}
              </div>
            );
          },
        },
      ],
    };

    this.remoteData = this.remoteData.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
  }

  componentDidMount() {
    // this.fetchData();
  }

  remoteData = (query) => {
    return client
      .query({
        query: QUERY_CHEQUE_AUDITS,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
          id: this.props.chequeId,
          cheque_id: this.props.cheque_id,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.ChequeAuditsQuery.data,
          page: query.page,
          totalCount: data.ChequeAuditsQuery.total,
        };
      });
  };

  updateSearch(fields) {
    this.setState({
      search: fields,
    });
    this.tableRef.current.onQueryChange();
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.type != nextProps.type) {
      this.tableRef.current.onQueryChange();
      return true;
    }
    return false;
  }

  render() {
    const { columns, data, actions, detailPanel } = this.state;

    return (
      <div>
        <MaterialTableRtl
          tableRef={this.tableRef}
          columns={columns}
          detailPanel={detailPanel}
          data={this.remoteData}
          perPage={this.props.perPage}
          needExport={true}
          title={"تغییرات چک"}
          pdfName={"تغییرات چک"}
        />
      </div>
    );
  }
}

export default withRouter(ChequeAuditsList);
